module.exports = __webpack_public_path__ + "img/mwc-hero.d4ee374a.png";